import axios from 'axios';

const axiosInstance = axios.create();

export interface Business {
  name: string,
  signer: Contact,
}

export interface Contact {
  ownership?: number,
  ssn?: string,
}

export const getBusiness = async (): Promise<Business> => {
  const response = await axiosInstance.get<Business>('/merchantGraph/contact');
  return response.data;
};

export const updateBusiness = async (business: Business): Promise<void> => {
  await axiosInstance.post<Business>('/merchantGraph/contact', business);
};
